<template lang="pug">
v-alert.mb-6(
  :type="!contract.isPaymentPrePayment ? 'info' : 'warning'"
  :color="!contract.isPaymentPrePayment ? 'error' : 'warning'"
  text outlined
)
  p
    span.mr-2 Вы будете обучаться на основании договора:
    strong.mr-2 №{{ contract.number }}
    v-btn(color="error" x-small  depressed target="_blank" :href="contract.document.url")
      v-icon(small).pr-1 mdi-file-download
      span скачать договор
  template(v-if="$user.data.id !== contract.owner_id")
    p.
      Заказчиком по договору пока не осуществлена предусмотренная,
      как условие для начала обучения оплата по договору.
      Вы сможете начать обучение сразу, как это будет им сделано
  template(v-else-if="!contract.isAllPayed")
    p(v-if="!isMobile") Полная стоимость обучения:
      strong  {{ contract.sum }} руб.
    div(
      v-if="!contract.isPaymentPrePayment"
      :class="{ 'pb-2': isMobile }"
    ) Сумма, вносимая до
      strong  {{ getDays('period_end') }}
      span  не менее
      strong  {{ contract.prePaymentValue }}  руб.
    p(
      v-if="!isMobile || (isMobile && contract.isPaymentPrePayment)"
    ) Полная сумма оплаты должна быть внесена до
      strong  {{ getDays('end_learning') }}

    p(
      v-if="contract.payment < contract.sum && !isMobile"
    ) Пожалуйста, не забудьте внести необходимую оплату по договору
    v-row.ma-0
      v-spacer
      v-btn(
        small depressed
        :color="contract.isPaymentPrePayment ? 'success' : 'error'"
        @click="openPaymentModal"
      ) перейти к оплате
  p(v-else) Курс полностью оплачен
</template>

<script>
import {
  addDays,
  format,
} from 'date-fns';
import PaymentModal from '@/modules/PaymentSystem/components/PaymentModal.vue';

export default {
  props: {
    contract: { type: Object, default: () => {} },
    course: { type: Object, default: () => {} },
  },
  computed: {
    isMobile() {
      return !this.$vuetify.breakpoint.mdAndUp;
    },
  },
  mounted() {
    if (this.$route.query.payment) this.openPaymentModal();
  },

  methods: {
    openPaymentModal() {
      const {
        maxPayment, isPaymentPrePayment, prePaymentValue, payment,
      } = this.contract;
      this.$modals.show('generic-controller', {
        title: 'Оплата по договору',
        component: PaymentModal,
        dialogProps: {
          width: 800,
        },
        'component-props': {
          needToPay: true,
          contract: this.contract,
          paymentValue: isPaymentPrePayment ? maxPayment : (prePaymentValue - payment),
        },
      });
    },
    getDays(type) {
      // - period_end, end_learning
      const types = this.course?.priority_user_prior_record;
      const amount = this.contract.typical_contract.day_before_course_end;
      return format(addDays(new Date(types[type]), -amount), 'dd.MM.yyyy');
    },
  },
};
</script>
